export default __webpack_public_path__ + "static/media/tick.33315307.png";